export default (theme) => ({
  root: {
    color: '#0B8DDE',
    fontWeight: 600,
    '&:hover': {
      cursor: 'pointer'
    }
  }
})
